import React from "react";
import imageCompression from "browser-image-compression";

const options = {
  maxSizeMB: 0.8,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  initialQuality : 0.7
};

export const compressFile = async (files, optionsOverride = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const compressedFile = await imageCompression(files, { ...options, ...optionsOverride });
      resolve(compressedFile)
    } catch (error) {
      reject(error);
    }
  });
};
